// src/auth/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  // FIX: We now also get the 'authReady' state from our context.
  const { user, authReady } = useAuth();

  // If the initial authentication check is still loading,
  // we show a loading screen (or nothing) to prevent the redirect glitch.
  if (!authReady) {
    return (
        <div className="min-h-screen grid place-items-center bg-[#0b0b12] text-white">
            <div className="opacity-80">Loading...</div>
        </div>
    );
  }

  // Once the auth check is complete, if there is still no user,
  // we redirect to the login page.
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If the auth check is complete and there is a user, we show the page.
  return children;
}
